import { render, staticRenderFns } from "./OverlayLoader.vue?vue&type=template&id=777fb5c6&scoped=true&"
import script from "./OverlayLoader.vue?vue&type=script&lang=js&"
export * from "./OverlayLoader.vue?vue&type=script&lang=js&"
import style0 from "./OverlayLoader.vue?vue&type=style&index=0&id=777fb5c6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "777fb5c6",
  null
  
)

export default component.exports